const removePrefix = (str: string) => {
  const formattedStr = str.replace(/^\d{1,2}_\d{1,2}_\d{4}\./, "");
  return formattedStr;
};

export default removePrefix;